import { useState, useEffect, useCallback } from 'react'

const useRecaptchaV3 = (siteKey) => {
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false)

  useEffect(() => {
    let script = document.querySelector('#recaptcha-script')

    if (!script) {
      script = document.createElement('script')
      script.id = 'recaptcha-script'
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
      script.async = true
      script.onload = () => setIsRecaptchaReady(true)
      document.body.appendChild(script)
    } else {
      setIsRecaptchaReady(true)
    }

    return () => {
      // DOM
      const scriptElement = document.querySelector('#recaptcha-script')
      if (scriptElement) {
        scriptElement.remove()
      }

      // window
      if (window.grecaptcha) {
        delete window.grecaptcha
      }

      const badge = document.querySelector('.grecaptcha-badge')
      if (badge) {
        badge.remove()
      }

      setIsRecaptchaReady(false)
    }
  }, [siteKey])

  const executeRecaptcha = useCallback(
    async (action) => {
      if (!isRecaptchaReady || !window.grecaptcha) {
        console.warn('reCAPTCHA belum siap, coba lagi.')
        return null
      }

      try {
        return await window.grecaptcha.execute(siteKey, { action })
      } catch (error) {
        console.error('Error executing reCAPTCHA:', error)
        return null
      }
    },
    [isRecaptchaReady, siteKey],
  )

  return executeRecaptcha
}

export default useRecaptchaV3
